import { Component, OnInit, Input } from '@angular/core';

@Component({
    moduleId: module.id,
    selector: 'overlay',
    templateUrl: 'overlay.component.html'
})
export class OverlayComponent {
    @Input() showOverlay: boolean = true;
}


// WEBPACK FOOTER //
// ./src/app/shared/overlay.component.ts